import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function exportServiceRequestMetrics(): Promise<Response> {
  const res = await fetcher(
    `${API_BASE_PATH}/metrics/export`,
    {
      method: 'GET',
    },
    undefined,
    undefined,
    {} // Empty headers to avoid Content-Type: application/json for binary response
  );

  return res;
}
